import { httpClient } from "./httpClient";
import { Session } from "./types";

export async function getSession(): Promise<Session> {
  try {
    const { data } = await httpClient.get<Session>(`/api/v1/session`);
    return data;
  } catch (error) {
    throw error;
  }
}
